import { featuredStory } from "@/mocks/positiveNews";

export default function FeaturedSection() {
  return (
    <section id="featured" className="bg-background-50 py-14 md:py-20">
      <div className="mx-auto max-w-7xl px-4 md:px-6">
        <p className="mb-2 flex items-center gap-2 text-xs font-medium tracking-widest text-primary-600">
          <span className="h-px w-6 bg-primary-400" />
          本期高光 · FEATURED
        </p>
        <div className="mb-8 flex flex-col gap-2 md:flex-row md:items-end md:justify-between">
          <h2 className="font-heading text-2xl font-bold text-foreground-950 md:text-4xl">把发光的瞬间收藏起来</h2>
          <p className="text-sm text-foreground-600 md:text-base">每周深度还原一个值得被记住的人物与时刻。</p>
        </div>

        <article className="group relative overflow-hidden rounded-3xl">
          <div className="relative h-[420px] w-full md:h-[560px]">
            <img
              src={featuredStory.img}
              alt={featuredStory.title}
              className="h-full w-full object-cover object-top transition-transform duration-700 group-hover:scale-105"
            />
            <div className="absolute inset-0 bg-gradient-to-t from-background-950/90 via-background-950/40 to-background-950/10" />
            <div className="absolute inset-x-0 bottom-0 p-6 md:p-12">
              <div className="flex items-center gap-3">
                <span className="inline-flex items-center gap-1.5 whitespace-nowrap rounded-full bg-accent-500 px-3 py-1 text-xs font-semibold text-foreground-950">
                  <i className="ri-vip-crown-2-fill" />
                  {featuredStory.cat}
                </span>
                <span className="text-xs text-background-200">{featuredStory.date}</span>
              </div>
              <h2 className="font-heading mt-4 max-w-3xl text-2xl font-bold leading-snug text-background-50 md:text-4xl md:leading-snug">
                {featuredStory.title}
              </h2>
              <p className="mt-4 max-w-2xl text-sm leading-relaxed text-background-100 md:text-base">{featuredStory.summary}</p>
              <a
                href="#people"
                className="mt-6 inline-flex items-center gap-1 whitespace-nowrap rounded-full border border-background-50/40 px-5 py-2.5 text-sm text-background-50 transition-colors hover:bg-background-50/15 cursor-pointer"
              >
                更多凡人英雄
                <i className="ri-arrow-right-line" />
              </a>
            </div>
          </div>
        </article>
      </div>
    </section>
  );
}